import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface Testimonial {
  id: string;
  name: string;
  location: string;
  quote: string;
  saint: string;
  image: string;
  alt: string;
  rating: number;
}

const testimonials: Testimonial[] = [
{
  id: 'test_1',
  name: 'Maria Rodriguez',
  location: 'Texas, USA',
  quote: 'I was searching for a saint to help with my anxiety and found St. Dymphna through SaintSeek. Her prayer has brought me so much peace.',
  saint: 'St. Dymphna',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_11984bfac-1763296141464.png",
  alt: 'Maria Rodriguez smiling woman with dark hair',
  rating: 5
},
{
  id: 'test_2',
  name: 'John O\'Brien',
  location: 'Dublin, Ireland',
  quote: 'As a teacher, I prayed to St. John Bosco before my classes. SaintSeek helped me learn his story and find beautiful prayer cards for my students.',
  saint: 'St. John Bosco',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_15e31a162-1763295583486.png",
  alt: 'John O\'Brien middle-aged man with beard',
  rating: 5
},
{
  id: 'test_3',
  name: 'Sophie Chen',
  location: 'California, USA',
  quote: 'Lost my grandmother\'s ring and prayed to St. Anthony. Found it the next day! The prayer I got from SaintSeek was exactly what I needed.',
  saint: 'St. Anthony',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_12033a8b7-1763300650349.png",
  alt: 'Sophie Chen young woman with glasses and black hair',
  rating: 5
},
{
  id: 'test_4',
  name: 'Father Michael',
  location: 'Boston, USA',
  quote: 'I recommend SaintSeek to all my parishioners. The depth of information and beautiful merchandise makes it easy to grow in devotion to the saints.',
  saint: 'Multiple Saints',
  image: "https://images.unsplash.com/photo-1711786005664-f5b552ffcbaf",
  alt: 'Father Michael priest with white collar',
  rating: 5
}];


export default function TestimonialsSection() {
  return (
    <section className="py-24 px-6 reveal">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-semibold text-primary uppercase tracking-wider mb-3">
            Testimonials
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-foreground mb-4">
            Stories of Faith
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Hear from our community about how the saints have interceded in their lives
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial) =>
          <div
            key={testimonial.id}
            className="glass-card p-8 rounded-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            
              {/* Rating Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) =>
              <Icon
                key={i}
                name="StarIcon"
                size={16}
                className="text-accent fill-current" />

              )}
              </div>

              {/* Quote */}
              <blockquote className="text-foreground mb-6 leading-relaxed font-serif italic">
                "{testimonial.quote}"
              </blockquote>

              {/* Saint Badge */}
              <div className="inline-flex items-center gap-2 bg-primary/10 text-primary px-3 py-1.5 rounded-full text-xs font-medium mb-6">
                <Icon name="SparklesIcon" size={14} />
                <span>Prayed to {testimonial.saint}</span>
              </div>

              {/* Author */}
              <div className="flex items-center gap-4 pt-6 border-t border-border">
                <div className="w-12 h-12 rounded-full overflow-hidden ring-2 ring-primary/20">
                  <AppImage
                  src={testimonial.image}
                  alt={testimonial.alt}
                  className="w-full h-full object-cover" />
                
                </div>
                <div>
                  <div className="font-semibold text-foreground">
                    {testimonial.name}
                  </div>
                  <div className="text-sm text-muted-foreground">
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

}